import compareMap from 'assets/images/landing/homepage/compare-map-pin.svg';
import deals from 'assets/images/landing/homepage/deals.svg';
import noMoneyIcon from 'assets/images/landing/homepage/no-money-icon.svg';

const stepsCards = [
	{
		imageSrc: compareMap,
		step: 'STEP 1',
		title: 'Search by City or Zip',
		description:
			'Simply enter your location to start exploring self storage options in your area.',
	},
	{
		imageSrc: deals,
		step: 'STEP 2',
		title: 'Find The Best Storage Deals',
		description:
			'Compare storage units, facility reviews, and  prices to find the best deal.',
	},
	{
		imageSrc: noMoneyIcon,
		step: 'STEP 3',
		title: 'Make a Free Reservation',
		description: 'Reserve online or by phone with no credit card required.',
	},
];

export default stepsCards;
